import { Observable } from 'rxjs/internal/Observable';
import { of } from 'rxjs/internal/observable/of';

export const handleError = <T>(operation = 'operation', result?: T) => {
  return (error: unknown): Observable<T> => {
    console.error(operation, error);
    return of(result as T);
  };
};

export default handleError;
